import { batteryDescriptionHTML } from './battery-description';

export const getGroupDescription = (
  id: number,
  name = '',
  vehicleText = ''
): string | null => {
  switch (id) {
    case 1829:
      return batteryDescriptionHTML(vehicleText);
    default:
      return getDefaultGroupDescription(name);
  }
};

const getDefaultGroupDescription = (name: string): string => {
  return `
  <p> En <strong>ALLAS REPUESTOS</strong>, somos especialistas en <strong>${name}</strong> en Honduras.
  Con más de 35 años de experiencia, ofrecemos el catálogo más amplio de repuestos automotrices del país.
  </p>
  <p>
  Nuestros productos incluyen las mejores marcas internacionales con garantía extendida, instalación profesional
  y servicio técnico especializado en todas nuestras sucursales a nivel nacional.
  </p>`;
};
